import { render, staticRenderFns } from "./DatumnManage.vue?vue&type=template&id=1f5b2aaa&scoped=true&"
import script from "./DatumnManage.vue?vue&type=script&lang=js&"
export * from "./DatumnManage.vue?vue&type=script&lang=js&"
import style0 from "./DatumnManage.vue?vue&type=style&index=0&id=1f5b2aaa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b2aaa",
  null
  
)

export default component.exports